<template>
  <div class="bm-progress">
    <div class="progress-container">
      <div 
        v-for="(step, index) in displaySteps" 
        :key="`step-${index}`"
        class="step-wrapper"
      >
        <div class="progress-item">
          <!-- 步骤圆圈 -->
          <div 
            class="step-circle" 
            :class="{ 
              'completed': isCompleted(index), 
              'active': isActive(index),
              'pending': isPending(index)
            }"
          >
            <!-- 已完成：显示勾选图标 -->
            <svg 
              v-if="isCompleted(index)" 
              class="check-icon" 
              viewBox="0 0 24 24" 
              fill="none"
            >
              <path 
                d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" 
                fill="white" 
                stroke="white" 
                stroke-width="2"
              />
            </svg>
            <!-- 当前步骤或待完成：显示数字 -->
            <span 
              v-else 
              class="step-number"
              :class="{ 'active-number': isActive(index) }"
            >
              {{ String(index + 1).padStart(2, '0') }}
            </span>
          </div>
          
          <!-- 步骤文字 -->
          <div 
            class="step-text" 
            :class="{ 
              'completed': isCompleted(index), 
              'active': isActive(index),
              'pending': isPending(index)
            }"
          >
            {{ step.title }}
          </div>
        </div>
        
        <!-- 箭头（最后一个步骤不显示） -->
        <div 
          v-if="index < displaySteps.length - 1" 
          class="step-arrow"
        >
        <img v-if="index >= displayCurrentStep" src="@/assets/bm/nextIcon_g.png" class="arrow-svg">
        <img v-else src="@/assets/bm/nextIcon_b.png" class="arrow-svg">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BmProgress',
  props: {
    // 步骤列表，格式：[{ title: '步骤名称' }]
    steps: {
      type: Array,
      required: true,
      default: () => []
    },
    // 当前激活的步骤索引（从0开始），用于高亮显示
    currentStep: {
      type: Number,
      default: 0
    }
  },
  computed: {
    shouldHideNoticeStep() {
      return sessionStorage.getItem('BM_NOTICE_OPTIONAL_SKIPPED') === '1'
    },
    displaySteps() {
      if (!Array.isArray(this.steps)) {
        return []
      }
      if (!this.shouldHideNoticeStep) {
        return this.steps
      }
      return this.steps.filter((step, index) => !(index === 0 && step && step.title === '阅读报名须知'))
    },
    displayCurrentStep() {
      const maxIndex = Math.max(this.displaySteps.length - 1, 0)
      let mappedStep = this.currentStep
      if (this.shouldHideNoticeStep && Array.isArray(this.steps) && this.steps[0] && this.steps[0].title === '阅读报名须知') {
        mappedStep = Math.max(this.currentStep - 1, 0)
      }
      return Math.min(Math.max(mappedStep, 0), maxIndex)
    }
  },
  methods: {
    // 判断是否为已完成步骤（索引小于currentStep）
    isCompleted(index) {
      return index < this.displayCurrentStep
    },
    // 判断是否为当前激活步骤
    isActive(index) {
      return index === this.displayCurrentStep
    },
    // 判断是否为待完成步骤（索引大于currentStep）
    isPending(index) {
      return index > this.displayCurrentStep
    }
  }
}
</script>

<style lang="scss" scoped>
.bm-progress {
  width: 100%;
}

.progress-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
}

.step-wrapper {
  display: flex;
  align-items: flex-start;
  flex: 0 0 auto;
}

.progress-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 0 0 auto;
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  
  &.completed {
    background: #1890ff;
    border: none;
  }
  
  &.active {
    background: transparent;
    border: 2px solid #1890ff;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
  }
  
  &.pending {
    background: transparent;
    border: 2px solid #D9D9D9;
  }
}

.check-icon {
  width: 20px;
  height: 20px;
}

.step-number {
  font-size: 14px;
  font-weight: 500;
  color: #D9D9D9;
  transition: color 0.3s ease;
  
  &.active-number {
    color: #1890ff;
    font-weight: 600;
  }
}

.step-text {
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
  transition: color 0.3s ease;
  
  &.completed {
    color: #1890ff;
    font-weight: 600;
  }
  
  &.active {
    color: #1890ff;
    font-weight: 500;
  }
  
  &.pending {
    color: #1A1A1A;
  }
}

.step-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px;
  margin-top: 0;
  flex-shrink: 0;
  
  .arrow-svg {
    height: 36px;
    margin: 0 15px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .progress-container {
    flex-direction: column;
    gap: 20px;
  }
  
  .step-arrow {
    position: static;
    transform: rotate(90deg);
    margin: 8px 0;
  }
  
  .step-text {
    white-space: normal;
    max-width: 120px;
  }
}
</style>